import React from 'react';
import { Transition } from 'react-transition-group';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// BASE
// ==============================

/**
  To achieve a "lazy mount" and clean up our component after unmounting,
  the following props must be set to true:
  - appear
  - mountOnEnter
  - unmountOnExit

  Read more https://reactcommunity.org/react-transition-group/#Transition-prop-mountOnEnter
*/
function LayerAnimation(_ref) {
  var _ref$component = _ref.component,
      Tag = _ref$component === void 0 ? 'div' : _ref$component,
      hasEntered = _ref["in"],
      onEntered = _ref.onEntered,
      onExited = _ref.onExited,
      style = _ref.style,
      styleDefault = _ref.styleDefault,
      transition = _ref.transition,
      enterDuration = _ref.enterDuration,
      exitDuration = _ref.exitDuration,
      props = _objectWithoutProperties(_ref, ["component", "in", "onEntered", "onExited", "style", "styleDefault", "transition", "enterDuration", "exitDuration"]);

  var transitionProps = {
    appear: true,
    "in": hasEntered,
    mountOnEnter: true,
    onEntered: onEntered,
    onExited: onExited,
    timeout: {
      enter: enterDuration,
      exit: exitDuration
    },
    unmountOnExit: true
  };
  return /*#__PURE__*/React.createElement(Transition, transitionProps, function (state) {
    var transitionState = transition ? transition[state] // we dont use the unmounted state so filter it out here
    : {};

    var styles = _objectSpread(_objectSpread(_objectSpread({}, style), styleDefault), transitionState);

    return /*#__PURE__*/React.createElement(Tag, _extends({
      style: styles
    }, props));
  });
}

export { LayerAnimation as default };
